import React from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Label } from '@abyss/web/ui/Label';
import { SingleSignOnController } from './SingleSignOn.Controller';

export const SingleSignOn = () => {
  SingleSignOnController();

  return (
    <Box
      css={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Label color="$gray6">Signing you in with Microsoft...</Label>
    </Box>
  );
};